module.exports = __webpack_public_path__ + "static/media/jones-engineering.f09fff47.jpg";